<template>
	<v-row class="my-0">
		<v-col md="8" sm="12" class="pr-0 py-0">
			<v-img :src="Banner002" class="fill-height" />
		</v-col>
		<v-col md="4" sm="12" class="pl-0 py-0 pb-md-0">
			<v-sheet color="accent" class="d-flex flex-column justify-center fill-height pa-3 ml-3 ml-sm-0 text-center white--text">
				<span style="line-height: normal">
					ГУМ-Ярмарка открыта <br />
					на Красной площади <br />
					с 30 ноября 2025 по 01 марта 2026
					<!-- {{ WorkHours }} -->
				</span>
				<a @click.prevent="ScrollTo('#yandex-map')" class="white--text my-2" href="#yandex-map">Посмотреть на карте</a>
			</v-sheet>
		</v-col>
	</v-row>
</template>

<script lang="ts">
import { WORKHOURS } from '@/main';
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionInfoYarmarka',
	data: () => ({
		Banner002: require('@/assets/images/yarmarka-top-banner.png'),
		Dialog: false,
		WorkHours: WORKHOURS,
	}),
	methods: {
		ScrollTo(selector: string) {
			let el = document.querySelector(selector);
			if (el) el.scrollIntoView();
		},
	},
});
</script>
